import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

const CriteriaRow = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(0.5),
  marginTop: theme.spacing(1),
  minWidth: 0,
  width: "100%",
  "& > .MuiChip-root": {
    // A long name is clipped inside its chip rather than pushing the row wider than the table.
    maxWidth: "100%",
  },
}));

/** One filter on the list, said in words, and how to take it off. */
export type FilterCriterionItem = Readonly<{ key: string; text: string; onRemove: () => void }>;

/**
 * The filters a list is narrowed by, each a chip that removes it, and *Clear filters* (#6714).
 *
 * The one row a list page draws them in, whatever set them: a criterion a link brought
 * (`WorkRecordCriteriaChips`, #6221) or a column filter (`ColumnFilterChips`). A filter kept on the
 * reader's account would otherwise hide rows with no visible cause, so every filter is shown here,
 * even while the column filter row is closed.
 */
export function FilterCriteriaRow(
  props: Readonly<{
    items: readonly FilterCriterionItem[];
    /** Takes every filter in the row off at once, in one change to the list. */
    onClearAll?: () => void;
  }>,
) {
  const { items, onClearAll } = props;
  if (items.length === 0) return null;
  return (
    <CriteriaRow role="group" aria-label="Filtered by">
      <Typography variant="body2" color="text.secondary" component="span">
        Filtered by
      </Typography>
      {items.map((item) => (
        <Chip
          key={item.key}
          label={item.text}
          aria-label={`Remove filter: ${item.text}`}
          size="small"
          onClick={item.onRemove}
          onDelete={item.onRemove}
        />
      ))}
      {onClearAll && (
        <Button size="small" onClick={onClearAll}>
          Clear filters
        </Button>
      )}
    </CriteriaRow>
  );
}
